import React, { useState, useEffect } from "react";
import { PersistGate } from "redux-persist/integration/react";
import { LicenseInfo } from "@material-ui/x-grid";

import { X_GRID_LICENSE_KEY } from "./config";
import configureStore from "./store";
import Providers from "./Providers";
import BaseRouter from "./router";
import { captureAttributionFromUrl } from "./utils/attribution";
import { captureConsentFromUrl } from "./utils/consent";
import { captureReferralFromUrl } from "./utils/referral";
import { installHttpsCallableRevokeInterceptor } from "./utils/installHttpsCallableRevokeInterceptor";

// Save the landing-page cookie choice first, so after an opt-out the GA ids
// below are dropped and the Meta Pixel never loads.
captureConsentFromUrl();
// Persist marketing attribution (GA4 client/session id + UTMs) from the signup
// URL before React mounts so it survives the whole signup flow.
captureAttributionFromUrl();
// Persist Tapfiliate's `ref` the same way. The signup link also carries
// campaign and consent params, and a later page in this flow has none of them.
captureReferralFromUrl();

LicenseInfo.setLicenseKey(X_GRID_LICENSE_KEY);

const App = () => {
  const [rootStore, setRootStore] = useState<any | undefined>(undefined);

  useEffect(() => {
    const initStore = async () => {
      const { store, persistor } = await configureStore();
      installHttpsCallableRevokeInterceptor(store);
      setRootStore({ store, persistor });
    };
    initStore();
  }, []);

  if (!rootStore) {
    return null;
  }
  return (
    <Providers store={rootStore.store}>
      <PersistGate loading={null} persistor={rootStore.persistor}>
        <BaseRouter />
      </PersistGate>
    </Providers>
  );
};

export default App;
